const styles = () => ({
  root: {
    marginTop: 12,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 8,
  },
  sessionList: {
    marginBottom: 12,
  },
  sessionRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 0',
    borderBottom: '1px solid #eee',
    fontSize: 14,
  },
  sessionDate: {
    width: 110,
    fontWeight: 600,
  },
  sessionMeta: {
    flex: 1,
  },
  sessionNote: {
    color: '#656565',
    fontStyle: 'italic',
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: 12,
  },
  field: {
    minWidth: 120,
    marginRight: 12,
    marginBottom: 8,
  },
  noteField: {
    minWidth: 240,
    marginRight: 12,
    marginBottom: 8,
  },
  saveButton: {
    marginBottom: 8,
  },
  emptyState: {
    color: '#656565',
    marginBottom: 12,
  },
});

export default styles;
